import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EntityModel } from '@data-layer/models/entities';

@Component({
  selector: 'app-marine-insurance-beneficiary-view-card',
  templateUrl: './marine-insurance-beneficiary-view-card.component.html',
  styleUrls: ['./marine-insurance-beneficiary-view-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceBeneficiaryViewCardComponent {
  @Input() public beneficiary: EntityModel;
  @Input() public isManagement: boolean;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();
}
